<template>
  <div>
    <!--    <div style="display: block">-->
    <!--      <el-dialog width="60vw" title="Chi tiết công việc" v-if="isShowTodoDetail"-->
    <!--                 :visible.sync="isShowTodoDetail" :destroy-on-close="true">-->
    <!--        <TodoDetail :selected-account="{accountId:accountId}" :todo-item="params.item"-->
    <!--                    @closeDialog="isShowTodoDetail = false" />-->
    <!--      </el-dialog>-->
    <!--    </div>-->
    <div class="fw-semibold font-size-14  mb-2" style="color: #0A58C0">{{ item.description }}</div>
    <div class="mb-2">{{ item.content }}</div>
    <div class="mb-2"
         style="color: white; border-bottom: 2px solid white;margin-left: -20px;margin-right: -20px; "></div>
    <div class="mb-1 fw-semibold"><img src="/assets/icon/ic_task_message.svg" class="me-2" /> {{ getMessageTitle() }}
    </div>
    <div class="mb-2 ms-2" v-html="getStatus(item,accountId)">{{ getStatus(item, accountId) }}</div>
    <el-button size="mini" type="primary" @click="remidTask()" v-if="isRemidTask()">Nhắc nhở</el-button>
    <el-button size="mini" type="primary" class="me-2" @click="acceptTask(item,accountId)" v-if="isAcceptTask()">Nhận
      việc
    </el-button>
    <el-button size="mini" type="primary" v-if="isFinishTask()" @click="finishTask(item,accountId)">Hoàn thành
    </el-button>
    <el-popover v-model="hidden" placement="bottom" width="300" trigger="click">
      <el-input type="textarea" placeholder="Nhập nội dung tin nhắn" :row="2" v-model="messageText"></el-input>
      <div class="d-flex justify-content-end">
        <el-button type="primary" size="mini" class="mt-2" @click="sendMessage()">Gửi</el-button>
      </div>
      <el-button class="mx-2" size="mini" slot="reference">Trả lời</el-button>
    </el-popover>
    <el-button @click="openTodo(message,item)" size="mini mb-1">Xem chi tiết</el-button>

  </div>
</template>

<script>

export default {
  name: "ChatTodo",
  props: {
    accountId: {
      type: String
    },
    message: {
      type: Object
    },
    members: {
      type: Array
    }
  },
  data() {
    return {
      hidden: false,
      messageText: "",
      isShowTodoDetail: false
    };
  },
  computed: {
    item() {
      let item = JSON.parse(JSON.parse(this.message.content).params).item;
      return item;
    }
  },
  methods: {
    sendMessage() {
      let message = this.item.extra;
      let req = {
        conversationId: this.app.selectedConversation.id,
        toId: this.app.selectedConversation.toId,
        accountId: this.app.selectedConversation.accountId,
        message: this.messageText,
        ownerId: this.item.creator,
        replyMsgId: message.msgId,
        replyMsgClientId: this.message.cliMsgId,
        replyMsgTs: this.message.ts,
        replyMsg: this.item.content
      };

      let url;
      if (message.isGroup) {
        url = "/api/message/replyGroupMessage";
      } else {
        url = "/api/message/replyMessage";
      }
      this.$http.post(url, req).then(() => {
      }).catch(() => {
        this.alert("error", "Có lỗi xảy ra ");
      }).finally(() => {
        this.messageText = "";
        this.hidden = false;
      });
    },

    // acceptTask(item) {
    //   let req = {
    //     accountId: this.accountId,
    //     params: JSON.stringify({ id: item.item.id, status: 0 })
    //   };
    //   this.$http.post("/api/todo/status", req).then(s => {
    //     if (s.data.error_code === 0) {
    //       this.alert("success", "Thao tác thành công");
    //     }
    //   });
    // },
    remidTask() {
      this.ding(this.item, this.accountId);
    },
    isAcceptTask() {
      if (this.item.status === 1) return false;
      if (this.accountId !== this.item.creator) {
        let item = this.item.assignees.find(s => s.userId === this.accountId);
        if (item && item.status === -1) {
          return true;
        }
      }
      return false;
    },
    isFinishTask() {
      if (this.item.status === 1) return false;
      if (this.accountId === this.item.creator) {
        if (this.item.assignees.find(s => s.userId === this.item.creator)) {
          return true;
        }
      }
      return false;
    },
    isRemidTask() {
      if (this.item.status === 1) return false;
      if (this.accountId === this.item.creator) {
        let userIds = this.item.assignees.map(s => s.userId);
        if (!userIds.includes(this.item.creator)) {
          return true;
        }
      }
      return false;
    },
    getMessageTitle() {
      if (this.members && this.members.length > 0) {
        let item = this.members.find(s => s.id == this.item.creator);
        if (item) {
          return item.name + " đã giao việc từ tin nhắn này cho " + this.item.assignees.length + " người.";
        }
      }
      return "Giao việc";
    }
    // getStatus() {
    //   if (this.params.item.status === -1) {
    //     return "Chưa nhận";
    //   }
    //   if (this.params.item.status === 1) {
    //     return "Đã hoàn thành";
    //   }
    //   return "";
    // },
    // finishTask() {
    //   let item = this.params;
    //   let req = {
    //     accountId: this.accountId,
    //     params: JSON.stringify({ id: item.item.id, status: 1 })
    //   };
    //   this.$confirm("Thông báo hoàn thành công việc.", "Warning", {
    //     confirmButtonText: "Xác nhận",
    //     cancelButtonText: "Hủy",
    //     type: "warning"
    //   }).then(async () => {
    //     this.$http.post("/api/todo/status", req).then(s => {
    //       if (s.data.error_code === 0) {
    //         this.alert("success", "Thao tác thành công");
    //       }
    //     });
    //   });
    // }
  },

  created() {
  }
};
</script>

<style scoped>

</style>